import React from 'react'
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import './Loading.css'
function Loading() {
  return (
    <div className='loading-screen'>
        <Spin indicator={<LoadingOutlined style={{ fontSize: '10rem', color:'white' }} spin />} />
    </div>
  )
}

export default Loading